    export interface ICreateUserRequest {
        email: string;
        password: string;
        roles: Array<string>;
        randomizePassword: boolean;
        firstName: string;
        lastName: string;
        enabled: boolean;
        range: number;
        addressLine1: string;
        addressLine2: string;
        city: string;
        zipCode: string;
        state: string;
        country: string;
        userId: number;
    }

    export class CreateUserRequest implements ICreateUserRequest {
        email: string;
        password: string;
        roles: Array<string>;
        randomizePassword: boolean;
        firstName: string;
        lastName: string;
        enabled: boolean;
        range: number;
        addressLine1: string;
        addressLine2: string;
        city: string;
        zipCode: string;
        state: string;
        country: string;
        userId: number;
    }